/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useRef } from 'react';
import { Tooltip, DialogUtility } from '@syncfusion/ej2-popups';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Toolbar,
  Edit,
  Sort,
  Filter,
  ForeignKey,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { Link, useNavigate } from 'react-router-dom';

import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { Query, DataManager } from '@syncfusion/ej2-data';
import { useStateContext } from '../contexts/ContextProvider';
import orgpng from '../data/organization.png';
import { risksGrid } from '../data/dummy';
import { Header } from '../components';
import scribeHow from '../data/scribehow.png';

const Risks = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=risks');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const grid = useRef(null);

  const { REACT_APP_API_ENDPOINT } = process.env;
  const [activeState, setActiveState] = useState('');
  const [row, setRow] = useState(false);
  const orgData = [];
  let crudUpdate = false;
  let crudCreate = false;
  let crudDelete = false;

  const handleClick = (e) => {
    // Check if the exact target element has the e-active class
    if (!e.target.classList.contains('e-active')) {
      setRow(true);
    } else {
      setRow(false);
      setActiveState('');
    }
  };
  let dialogInstance;
  const sensitivityLevel = () => (
    <div>
      {crudUpdate && (
        <div className="e-btn-group zackat-dashalh">
          Preset Sensitivty Level&nbsp;&nbsp;
          <ButtonComponent
            value="Low"
            cssClass={activeState === 'Low' ? 'custom-button' : ''}
            onClick={() => {
              setActiveState('Low');
              if (grid && grid.current) {
                dialogInstance = DialogUtility.confirm({
                  title: 'Preselect Low Sensitivity',
                  content: 'Would you like to load the factory default preselect parameters for LOW sensitivity?',
                  okButton: { text: 'OK',
                    click: () => {
                      const selectedRecords = grid.current.getSelectedRecords();
                      if (selectedRecords.length === 1) {
                        selectedRecords[0].temperature = '4';
                        selectedRecords[0].heartrate = '20';
                        selectedRecords[0].hrv = '30';
                        selectedRecords[0].risk = '15';
                        selectedRecords[0].oxygen = '10';
                        selectedRecords[0].hydration = '10';
                        selectedRecords[0].activity = '1000';
                        selectedRecords[0].alertlevel = 'elevatedplus';
                        setActiveState('');
                        grid.current.startEdit();
                        dialogInstance.hide();
                      }
                    } },
                  cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); setActiveState(''); } },
                  showCloseIcon: true,
                  closeOnEscape: true,
                  isModal: true,
                  animationSettings: { effect: 'Zoom' },
                });
              }
            }}
          >
            Low
          </ButtonComponent>
          <ButtonComponent
            value="Medium"
            cssClass={activeState === 'Medium' ? 'custom-button' : ''}
            onClick={() => {
              setActiveState('Medium');
              if (grid && grid.current) {
                dialogInstance = DialogUtility.confirm({
                  title: 'Preselect Medium Sensitivity',
                  content: 'Would you like to load the factory default preselect parameters for MEDIUM sensitivity?',
                  okButton: { text: 'OK',
                    click: () => {
                      const selectedRecords = grid.current.getSelectedRecords();
                      if (selectedRecords.length === 1) {
                        selectedRecords[0].temperature = '3';
                        selectedRecords[0].heartrate = '15';
                        selectedRecords[0].hrv = '30';
                        selectedRecords[0].risk = '15';
                        selectedRecords[0].oxygen = '10';
                        selectedRecords[0].hydration = '10';
                        selectedRecords[0].activity = '500';
                        selectedRecords[0].alertlevel = 'moderateplus';
                        setActiveState('');
                        grid.current.startEdit();
                        dialogInstance.hide();
                      }
                    } },
                  cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); setActiveState(''); } },
                  showCloseIcon: true,
                  closeOnEscape: true,
                  isModal: true,
                  animationSettings: { effect: 'Zoom' },
                });
              }
            }}
          >
            Medium
          </ButtonComponent>
          <ButtonComponent
            value="High"
            cssClass={activeState === 'High' ? 'custom-button' : ''}
            onClick={() => {
              setActiveState('High');
              if (grid && grid.current) {
                dialogInstance = DialogUtility.confirm({
                  title: 'Preselect High Sensitivity',
                  content: 'Would you like to load the factory default preselect parameters for HIGH sensitivity?',
                  okButton: { text: 'OK',
                    click: () => {
                      const selectedRecords = grid.current.getSelectedRecords();
                      if (selectedRecords.length === 1) {
                        selectedRecords[0].temperature = '2';
                        selectedRecords[0].heartrate = '7';
                        selectedRecords[0].hrv = '20';
                        selectedRecords[0].risk = '20';
                        selectedRecords[0].oxygen = '10';
                        selectedRecords[0].hydration = '10';
                        selectedRecords[0].activity = '100';
                        selectedRecords[0].alertlevel = 'all';
                        setActiveState('');
                        grid.current.startEdit();
                        dialogInstance.hide();
                      }
                    } },
                  cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); setActiveState(''); } },
                  showCloseIcon: true,
                  closeOnEscape: true,
                  isModal: true,
                  animationSettings: { effect: 'Zoom' },
                });
              }
            }}
          >
            High
          </ButtonComponent>
        </div>
      )}
    </div>
  );
  const toolbarOptions = ['Delete', 'Add', 'Edit', 'Search', 'ExcelExport'];
  const { activeMenu, zRenderMode, isMobile } = useStateContext();
  const selectionSettings = { mode: 'Row', type: 'Single', persistSelection: true };
  const valuerules = { required: true };
  let myScreenSize = 'auto';
  const {
    screenSize,
    setScreenSize,
  } = useStateContext();
  const tooltip = (args) => {
    const result = orgData.find(({ id }) => id === args.data.organizationid);
    let mycontent = '';
    switch (args.column.field) {
      case 'temperature':
        mycontent = 'Represents the graduation scale for the Temperature, ex. a temperature change of 2 degress multiplied time a RISK factor of 20 will result in an increase of 20 points';
        break;
      case 'oxygen':
        mycontent = 'Represents the graduation scale for the Oxygen, ex. an Oxygen change of 5% multiplied time a RISK factor of 10 will result in an increase of 10 points';
        break;
      case 'hydration':
        mycontent = 'Represents the graduation scale for the Hydration, ex. an Oxygen change of 10% multiplied time a RISK factor of 20 will result in an increase of 20 points';
        break;
      case 'heartrate':
        mycontent = 'Represents the graduation scale for the Heartrate, ex. a heartrate change of 10 BPM multiplied time a RISK factor of 20 will result in an increase of 20 points';
        break;
      case 'hrv':
        mycontent = 'Represents the graduation scale for the Heartrate Variability, ex. an HRV of <= 20% of an Associates BASELINE will result in a increase to the RISK level of 20 points. Also, a spike of 150% >= BASELINE will also result in 20 point increase to the RISK level.';
        break;
      case 'activity':
        mycontent = 'Not currently implemented';
        break;
      case 'age':
        mycontent = 'Represents the use of the Age graduation scale, used with Heartrate and Temperature, age group ranges are: 0-20, 21-30, 31-35, 36-40, 41-45, 45-50, 51-55, 56-60, 61-65, 66-70. ex. 0 means do not use age, 1 means use age when calculating RISK.';
        break;
      case 'male':
        mycontent = 'Represents the use of the Gender to factor to adjust RISK factor ex. 0 means do not use Gender, 1.1 means use a multiple of 1.1 when calculating RISK.';
        break;
      case 'female':
        mycontent = 'Represents the use of the Gender to factor to adjust RISK factor ex. 0 means do not use Gender, 1.2 means use a multiple of 1.1 when calculating RISK.';
        break;
      case 'risk':
        mycontent = 'Represents the incremental RISK factor from; HYPO (below normal: -1), BASELINE (0-25), MODERATE (25-50), ELEVATED (50-80), and SEVERE (80-100)';
        break;
      case 'organizationid':
        mycontent = `Represents which organization these factors apply: ${result.value}`;
        break;
      default:
        mycontent = '';
        break;
    }
    const tt = new Tooltip({
      content: mycontent,
    });
    tt.appendTo(args.cell);
  };

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  if (activeMenu === false) {
    myScreenSize = 'auto';
  } else {
    const s = (screenSize - 450).toString();
    myScreenSize = `${s}px`;
  }
  const gridOrgHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={orgpng}
        alt="organization"
      />
      <pre>Organization</pre>
    </div>
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const fields = [
    { value: 'all', text: 'All' },
    { value: 'moderateplus', text: 'Moderate and Above' },
    { value: 'elevatedplus', text: 'Elevated and Above' },
    { value: 'moderateplushypo', text: 'Moderate and Above + HYPO' },
    { value: 'elevatedplushypo', text: 'Elevated and Above + HYPO' },
  ];
  const smsLevel = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(fields),
      fields: { value: 'value', text: 'text' },
      query: new Query(),
    },
  };
  useEffect(() => {
    // limit associates to the overall selection
    setLoading(true);
    setRow(false);
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/risks?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });

      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [reload]);

  const actionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      const result = orgData.find(({ id }) => id === args.rowData.organizationid);

      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.width = '50vw';
        dialog.header = `Risk Factors: ${result.value} ${activeState !== '' ? `(${activeState} Sensitivity Factory Presets)` : ''}`;
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data) {
        setActiveState('');
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });

        fetch(`${REACT_APP_API_ENDPOINT}/risks`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
              DialogUtility.alert('Risk add failed');
              args.cancel = true;
              return;
            }
            if (responseJson && responseJson._id) {
              data.risks[0]._id = responseJson._id;
            }
            setReload(!reload);
          })
          .catch(() => {
            DialogUtility.alert('An error has occured during Insert!');
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      // Here you can send the updated data to your server using AJAX call
      setActiveState('');
      orgData.forEach((element) => {
        if (element.id === args.data.organizationid) {
          args.data.organizationid = element.id;
          args.data.organization = element.value;
        }
      });
      fetch(`${REACT_APP_API_ENDPOINT}/risks`, {
        method: 'UPDATE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(args.data),
      })
        .then((response) => response.json())
        .then(() => {
          // The added/edited data will be saved in the Grid
          // The default edit operation is cancelled
          grid.current.endEdit();
          setReload(!reload);
        })
        .catch(() => {
          DialogUtility.alert('An error has occured during Update!');
        });
    } else if (args.requestType === 'delete') {
      setActiveState('');
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/risks`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            setReload(!reload);
          })
          .catch(() => {
            DialogUtility.alert('An error has occured during Delete!');
          });
      }
    }
  };
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `Risks_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    }
  };

  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.role && data.role.alerts) {
    if (data.role.alerts.permissions.includes('Create')) {
      crudCreate = true;
    }
    if (data.role.alerts.permissions.includes('Update')) {
      crudUpdate = true;
    }
    if (data.role.alerts.permissions.includes('Delete')) {
      crudDelete = true;
    }
    if (!data.role.alerts.permissions.includes('Read')) {
      return <p>Not authorized...</p>;
    }
  }
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Dialog',
  };
  const editingMobile = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Normal',
  };
  if (data.organization) {
    data.organization.forEach((org) => {
      orgData.push({ id: org._id, value: org.title });
    });
  }
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  //          to="https://scribehow.com/viewer/Risk_threshold_and_configuration_settings__LLNJadhCThKgUojCxYUjjQ"

  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <div className="flex">
        <Link
          className="my-link"
          to="/pdf/risks.pdf"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="SafeGuards" title="Risk Threshold Factors" />
      </div>
      {row && (
      <div id="container">
        <ToolbarComponent id="toolbar">
          <ItemsDirective>
            <ItemDirective template={sensitivityLevel} disabled={false} />
            <ItemDirective type="Separator" />
          </ItemsDirective>
        </ToolbarComponent>
      </div>
      )}
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data.risks}
              width={myScreenSize}
              id="gridrisks"
              allowPaging
              allowSorting
              allowExcelExport
              pageSettings={{ pageSize: 20 }}
              editSettings={isMobile ? editingMobile : editing}
              enableStickyHeader={!isMobile}
              toolbar={toolbarOptions}
              recordClick={handleClick}
              toolbarClick={clickHandler}
              actionComplete={actionComplete}
              selectionSettings={selectionSettings}
              queryCellInfo={tooltip}
              allowTextWrap
              ref={grid}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
              enablePersistence
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {risksGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                <ColumnDirective
                  field="alertlevel"
                  headerText="SMS/EMAIL Level"
                  width="150"
                  textAlign="Left"
                  editType="dropdownedit"
                  foreignKeyField="value"
                  foreignKeyValue="text"
                  dataSource={smsLevel.params.dataSource}
                />
                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="150"
                  textAlign="Left"
                  editType="dropdownedit"
                  headerTemplate={gridOrgHeader}
                  edit={organizations}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  validationRules={valuerules}
                  dataSource={organizations.params.dataSource}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Toolbar, Edit, Sort, Filter, ForeignKey, ExcelExport]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Risks;
